import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const testimonials = [
  {
    name: "Ahmad Raza",
    designation: "Lahore, Pakistan",
    image: "/assets/img/testimonial/testi_1_1.jpg",
    text: "Himolan Peak Adventures made our Skardu trip absolutely unforgettable. The blossom season views were breathtaking, the Prado was comfortable, and our guide Zahid was knowledgeable and friendly throughout the journey.",
  },
  {
    name: "Sara Malik",
    designation: "Karachi, Pakistan",
    image: "/assets/img/testimonial/testi_1_2.jpg",
    text: "We booked the Hunza Cherry Blossom tour and it was beyond expectations. From Gilgit airport pickup to hotel stay and fort visits — everything was perfectly arranged. We will definitely book with them again!",
  },
  {
    name: "Usman Tariq",
    designation: "Islamabad, Pakistan",
    image: "/assets/img/testimonial/testi_1_1.jpg",
    text: "Our Fairy Meadows trek was a dream come true. The team handled every detail with care — the bonfire evenings with Nanga Parbat views in the background were truly once-in-a-lifetime moments.",
  },
  {
    name: "Bilal & Ayesha",
    designation: "Rawalpindi, Pakistan",
    image: "/assets/img/testimonial/testi_1_1.jpg",
    text: "We chose the Skardu Honeymoon Special package and it was absolutely perfect. The luxury vehicle, beautiful resort stay, and romantic arrangements made our honeymoon truly special. Highly recommended!",
  },
  {
    name: "Kamran Hussain",
    designation: "Peshawar, Pakistan",
    image: "/assets/img/testimonial/testi_1_2.jpg",
    text: "Highly recommend Himolan Peak Adventures for exploring Northern Pakistan. Very transparent about pricing, responsive on WhatsApp, and they truly go above and beyond for their clients. A five-star experience.",
  },
  {
    name: "Tariq Mehmood",
    designation: "Multan, Pakistan",
    image: "/assets/img/testimonial/testi_1_1.jpg",
    text: "Visited Naltar Valley and Hunza with Himolan Peak Adventures. The natural beauty of Gilgit-Baltistan is unreal and having a team that knows these routes made the whole experience smooth and safe.",
  },
];

function TestimonialOne() {
  return (
    <section className="testi-area overflow-hidden space shape-mockup-wrap" id="testi-sec">
      <div className="container-fluid p-0">
        <div className="title-area mb-20 text-center">
          <span className="sub-title">Testimonial</span>
          <h2 className="sec-title">What Clients Say About Us</h2>
        </div>
        <div className="slider-area">
          <Swiper
            modules={[Pagination, Navigation]}
            pagination={{ clickable: true }}
            spaceBetween={30}
            centeredSlides={true}
            loop={true}
            slidesPerGroup={1}
            speed={1200}
            breakpoints={{
              0: { slidesPerView: 1},
              767: { slidesPerView: 2},
              992: { slidesPerView: 2},
              1200: { slidesPerView: 2},
              1400: { slidesPerView: 3},
            }}
            className="testiSlider1 has-shadow"
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testi-card">
                  <div className="testi-card_wrapper">
                    <div className="testi-card_profile">
                      <div className="testi-card_avater">
                        <img src={item.image} alt="testimonial" />
                      </div>
                      <div className="media-body">
                        <h3 className="box-title">{item.name}</h3>
                        <span className="testi-card_desig">{item.designation}</span>
                      </div>
                    </div>
                    <div className="testi-card_review">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="fa-solid fa-star" />
                      ))}
                    </div>
                  </div>
                  <p className="testi-card_text">{item.text}</p>
                  <div className="testi-card-quote">
                    <img src="/assets/img/icon/testi-quote.svg" alt="img" />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="slider-pagination" />
        </div>
      </div>
      <div className="shape-mockup d-none d-xl-block" style={{bottom:"-2%", right:"0%"}}>
        <img src="/assets/img/shape/line2.png" alt="shape" />
      </div>
      <div className="shape-mockup movingX d-none d-xl-block" style={{top:"30%", left:"5%"}}>
        <img src="/assets/img/shape/shape_7.png" alt="shape" />
      </div>
    </section>
  );
}

export default TestimonialOne;
